import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rangePipe'
})
export class RangePipe implements PipeTransform {

  transform(value: string): string {
    return 'de '+value?.replace('-', ' à ');
  }

}
